import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// El evento se captura al cargar el modulo (no al montar el componente) para no
// perderlo si Chrome lo dispara antes de que el usuario haya iniciado sesion.
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn());
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn());
  });
}

function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

function isIos() {
  const ua = window.navigator.userAgent;
  const iPadOs = window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;
  return /iphone|ipad|ipod/i.test(ua) || iPadOs;
}

function InstallButton() {
  const { t } = useTranslation();
  const [promptEvent, setPromptEvent] = useState(deferredPrompt);
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    const sync = () => setPromptEvent(deferredPrompt);
    listeners.add(sync);
    sync();
    return () => {
      listeners.delete(sync);
    };
  }, []);

  if (isStandalone()) return null;
  const ios = isIos();
  if (!promptEvent && !ios) return null;

  const handleClick = async () => {
    if (promptEvent) {
      promptEvent.prompt();
      try {
        await promptEvent.userChoice;
      } catch (err) {
        // el usuario cerro el cuadro sin elegir
      }
      deferredPrompt = null;
      listeners.forEach((fn) => fn());
    } else {
      setShowIosHint((v) => !v);
    }
  };

  return (
    <div className="mb-2.5">
      <button
        onClick={handleClick}
        className="w-full bg-accent text-panel font-bold text-[13px] rounded-lg py-2.5 cursor-pointer"
      >
        {t('pwa.installApp')}
      </button>
      {showIosHint && <p className="text-muted text-[11px] mt-2">{t('pwa.iosHint')}</p>}
    </div>
  );
}

export default InstallButton;